import { useTranslation } from 'react-i18next'

const HeadRow = () => {
    const { t } = useTranslation()
    return (
        <thead>
            <tr className="sticky top-0 z-10 bg-cream-20 text-left text-lg text-grey-70">
                <th className="py-3.5 pl-2 text-center font-normal">
                    {t('STATISTICS_EMPLOYEES_TABLE_NO')}
                </th>
                <th className="py-3.5 font-normal">
                    {t('STATISTICS_EMPLOYEES_TABLE_AVATAR')}
                </th>
                <th className="py-3.5 font-normal">
                    {t('STATISTICS_EMPLOYEES_TABLE_NAME')}
                </th>
                <th className="py-3.5 font-normal text-center">
                    {t('STATISTICS_EMPLOYEES_TABLE_RATING')}
                </th>
                <th className="py-3.5 font-normal text-center">
                    {t('STATISTICS_EMPLOYEES_TABLE_TIPS')}
                </th>
            </tr>
        </thead>
    )
}

export default HeadRow
